<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "TentangKami",

  metaInfo: { title: "Tentang Kami" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt",
      "about-us",
      "core-values",
      "story",
      "boards",
      "financial-report",
      "non-financial-report",
      "info"
    ])
  ],

  props: {
    id: {
      type: String,
      default: "about"
    }
  }
};
</script>
